module.exports = __webpack_public_path__ + "static/media/reichstag.bfd8ecca.jpg";